"use strict";

const { default: Swal } = require("sweetalert2");
const config = require('../../../../../config/locales_json/packs/private/oferts/oferts.json');
const language = $('body').data("language");
const origin = $('#kt_datatable_oferts').data("p-origin");
var kt_datatable_oferts = undefined
// Class definition
var OfertsPrivateDatatable = function() {
  var _typeUser;
  // Private functions
  var _init = function() {
    var pathClients = document.location.pathname
    _typeUser = $('#kt_datatable_oferts').hasClass("admin") ? "admin" : "recruiter"
    var isMultiAccount = $('#kt_datatable_oferts').hasClass("is_multi_account")
    
    const platformUrl = document.location.origin;
    
    var datatable = $('#kt_datatable_oferts').KTDatatable({
      // datasource definition
      data: {
        type: 'remote',
        source: {
          read: {
            url: pathClients+'/get_oferts.json',
            method: 'GET',
            map: function(data) {
              if(data.data.statusCode) {
                const text = getTranslationValue(config, [language, "OfertsPrivateDatatable", "data", "status_code_swalfire_text"], "Lo sentimos!, ");
                Swal.fire({
                  text: text+data.data.message,
                  icon: "error",
                  buttonsStyling: false,
                  confirmButtonText: getTranslationValue(config, [language, "OfertsPrivateDatatable", "data", "status_code_swalfire_confirmButtonText"],"Aceptar"),
                  customClass: {
                      confirmButton: "btn btn-fj-purple"
                  }
                });

                return false;
              }

              const totalText = getTranslationValue(config, [language, "OfertsPrivateDatatable", "data", "total"], " Total");
              $("#kt_subheader_total").html(data.meta.total + totalText)

              setTimeout(() => {
                $('div#kt_datatable_oferts .tp').tooltip('enable');
                $('div#kt_datatable_oferts span').tooltip('enable');
              }, 2000);

              return data.data
            }
          },
        },
        search: true,
        pageSize: 10, // display 20 records per page
        serverPaging: true,
        serverFiltering: true,
        serverSorting: true
      },

      // layout definition
      layout: {
          scroll: false, // enable/disable datatable scroll both horizontal and vertical when needed.
          footer: false, // display/hide footer
      },

      // column sorting
      sortable: true,

      pagination: true,

      search: {
        input: $('#kt_subheader_oferts_search_form'),
        delay: 400,
        key: 's'
      },

			toolbar: {
				items: {
					pagination: {
						pageSizeSelect: [5, 10, 20],
					},
				},
			},

      translate: {
        records: {
          processing: getTranslationValue(config, [language, "OfertsPrivateDatatable", "translate", "records-processing"],'Cargando...'),
          noRecords: getTranslationValue(config, [language, "OfertsPrivateDatatable", "translate", "records-noRecords"],'No hay publicaciones')
        },
        toolbar: {
          pagination: {
            items: {
              default: {
                first: getTranslationValue(config, [language, "OfertsPrivateDatatable", "toolbar", "default-first"], 'Primero'),
                prev: getTranslationValue(config, [language, "OfertsPrivateDatatable", "toolbar", "default-prev"], 'Anterior'),
                next: getTranslationValue(config, [language, "OfertsPrivateDatatable", "toolbar", "default-next"], 'Siguiente'),
                last: getTranslationValue(config, [language, "OfertsPrivateDatatable", "toolbar", "default-last"], 'Último'),
                more: getTranslationValue(config, [language, "OfertsPrivateDatatable", "toolbar", "default-more"], 'Más páginas'),
                input: getTranslationValue(config, [language, "OfertsPrivateDatatable", "toolbar", "default-input"], 'Página number'),
                select: getTranslationValue(config, [language, "OfertsPrivateDatatable", "toolbar", "default-select"], 'Selecciona el tamaño de la página')
              },
              info: getTranslationValue(config, [language, "OfertsPrivateDatatable", "toolbar", "info"], 'Mostrando {{start}} - {{end}} de {{total}} publicaciones')
            }
          }
        }
      },

      // columns definition
      columns: [{
        field: 'title',
        title: getTranslationValue(config, [language, "OfertsPrivateDatatable", "columns", "title", "title"],'Publicaciones'),
        width: 200,
        template: function(data) {
          switch (data.type_work) {
            case 0:
              var type_work = getTranslationValue(config, [language, "OfertsPrivateDatatable", "columns", "title", "switch_case_0"],"Práctica, pasantía, internship")
              break;
            case 1:
              var type_work = getTranslationValue(config, [language, "OfertsPrivateDatatable", "columns", "title", "switch_case_1"],"Trabajo")
              break;
            case 2:
              var type_work = getTranslationValue(config, [language, "OfertsPrivateDatatable", "columns", "title", "switch_case_2"],"Banco de Talento")
              break;
            case 3:
              var type_work = getTranslationValue(config, [language, "OfertsPrivateDatatable", "columns", "title", "switch_case_3"],"Trabajo Operativo")
              break;
            default:
              var type_work = getTranslationValue(config, [language, "OfertsPrivateDatatable", "columns", "title", "switch_default"],"Sin información")
          }
          // Revisamos si la tabla es del admin
          var checkAdminUser = $("#kt_datatable_oferts").hasClass("admin")
          // Si es el admin
          if(checkAdminUser) {
            var slug = $("#kt_datatable_oferts").attr("data-slug")
            var url = '/admin/clientes/'+ slug +'/ofertas/'+ data.id +'/postulaciones'
          } else {
            var url = '/empresa/ofertas/'+ data.id +'/postulaciones'
          }

          var client_name = isMultiAccount ? ' | '+data.client_name : ''

          var output = '<div class="d-flex align-items-center">\
            <div class="ml-3">\
              <div class="text-dark-75 font-weight-bolder font-size-lg mb-0"><a href="'+ url +'" data-turbolinks="false" class="title-link">'+ data.title +'</a></div>\
              <span class="text-muted font-weight-bold">'+ type_work +' | '+ data.address + client_name +'</span>\
            </div>\
          </div>';

          return output;
        }
      },{
        field: 'postulations',
        title: getTranslationValue(config, [language, "OfertsPrivateDatatable", "columns", "postulations", "title"],'N°'),
        width: 50,
        template: function(data) {
          // Revisamos si la tabla es del admin
          var checkAdminUser = $("#kt_datatable_oferts").hasClass("admin")
          // Si es el admin
          if(checkAdminUser) {
            var slug = $("#kt_datatable_oferts").attr("data-slug")
            var url = '/admin/clientes/'+ slug +'/ofertas/'+ data.id +'/postulaciones'
          } else {
            var url = '/empresa/ofertas/'+ data.id +'/postulaciones'
          }

          var output = '<div class="d-flex align-items-center"><a href="'+ url +'" data-turbolinks="false" class="title-link">\
            <span class="label font-weight-bold label-rounded label-light-success count-postulations-label"><strong>'+ data.postulations +'</strong></span></a>\
          </div>';

          return output;
        }
      },{
        field: 'start_date',
        title: getTranslationValue(config, [language, "OfertsPrivateDatatable", "columns", "postulations", "start_date"],'Inicio'),
        sortable: 'desc',
        type: 'date',
        format: 'DD/MM/YYYY',
        width: 100,
        template: function(row) {
          if(row.start_date) {
            var output = '<div class="font-weight-bolder mb-0">' + _parsedDate(row.start_date) + '</div>';
          } else {
            const outputText = getTranslationValue(config, [language, "OfertsPrivateDatatable", "columns", "end_date", "output_text"],'No especifíca')
            var output = '<div class="font-weight-bolder mb-0">'+outputText+'</div>';
          }

          return output;
        }
      },{
        field: 'end_date',
        title: getTranslationValue(config, [language, "OfertsPrivateDatatable", "columns", "end_date", "title"],'Término'),
        sortable: 'desc',
        type: 'date',
        format: 'DD/MM/YYYY',
        width: 100,
        template: function(row) {
          if(row.end_date) {
            var output = '<div class="font-weight-bolder mb-0">' + _parsedDate(row.end_date) + '</div>';
          } else {
            const outputText = getTranslationValue(config, [language, "OfertsPrivateDatatable", "columns", "end_date", "output_text"],'No especifíca')
            var output = '<div class="font-weight-bolder mb-0">'+outputText+'</div>';
          }

          return output;
        }
      },{
        field: 'published_by',
        title: getTranslationValue(config, [language, "OfertsPrivateDatatable", "columns", "published_by", "title"],'Publicado por'),
        template: function(data) {
          var output = '<div class="d-flex align-items-center">\
            <div class="text-dark-75 font-weight-bolder font-size-lg mb-0">' + data.recruiter_first_name + ' ' + data.recruiter_last_name + '</div>\
          </div>';

          return output;
        }
      },{
        field: 'is_confidential',
        title: getTranslationValue(config, [language, "OfertsPrivateDatatable", "columns", "is_confidential", "title"],'Tipo'),
        width: 70,
        template: function(data) {
          if(data.is_confidential){
            var label = getTranslationValue(config, [language, "OfertsPrivateDatatable", "columns", "is_confidential", "is_confidential_label"],"Confidencial")
          } else {
            var label = getTranslationValue(config, [language, "OfertsPrivateDatatable", "columns", "is_confidential", "is_not_confidential_label"],"Público")
          }

          var output = '<div class="d-flex align-items-center">\
            <div class="text-dark-75 font-weight-bolder font-size-lg mb-0">'+ label +'</div>\
          </div>';

          return output;
        }
      },
      {
        field: 'Status',
        title: getTranslationValue(config, [language, "OfertsPrivateDatatable", "columns", "Status", "title"],'Estado'),
        width: 90,
        autoHide: false,
        // callback function support for column rendering
        template: function(row) {
          if(row.is_archived){
            var state = getTranslationValue(config, [language, "OfertsPrivateDatatable", "columns", "Status", "is_archived"],"Archivada")
            var classState = "label-closed"
          } else {
            switch (row.state) {
              case 0:
                var state = getTranslationValue(config, [language, "OfertsPrivateDatatable", "columns", "Status", "switch_case_0"],"Abierto")
                var classState = "label-open"
                break;
              case 1:
                var state = getTranslationValue(config, [language, "OfertsPrivateDatatable", "columns", "Status", "switch_case_1"],"Pausado")
                var classState = "label-paused"
                break;
              case 2:
                var state = getTranslationValue(config, [language, "OfertsPrivateDatatable", "columns", "Status", "switch_case_2"],"Cerrado")
                var classState = "label-closed"
                break;
              case 3:
                var state = getTranslationValue(config, [language, "OfertsPrivateDatatable", "columns", "Status", "switch_case_3"],"Pendiente")
                var classState = "label-pending"
                break;
              default:
                var state = getTranslationValue(config, [language, "OfertsPrivateDatatable", "columns", "Status", "switch_case_default"],"No existe este estado")
                var classState = ""
            }
          }

          // Revisamos si la tabla es del admin
          var checkAdminUser = $("#kt_datatable_oferts").hasClass("admin")
          var offerID = row.id
          // Si es el admin
          if(checkAdminUser) {
            var slug = $("#kt_datatable_oferts").attr("data-slug")
            var url = '/ofertas/'+ offerID +'/show_offer_state?slug=' + slug
          } else {
            var url = '/ofertas/'+ offerID +'/show_offer_state'
          }

          const spanTitle = getTranslationValue(config, [language, "OfertsPrivateDatatable", "columns", "Status", "return_title"],'Editar Estado')
          return '<a href="'+url+'" data-remote="true" id="status_'+ offerID +'"><span data-toggle="tooltip" data-theme="dark" title="'+spanTitle+'" class="label label-lg font-weight-bold label-inline '+ classState +'">'+ state +'</span></a>';
        }
      }, {
        field: 'Actions',
        title: getTranslationValue(config, [language, "OfertsPrivateDatatable", "columns", "Actions", "title"],'Acciones'),
        sortable: false,
        width: 130,
        overflow: 'visible',
        autoHide: false,
        template: function(row) {
          var urlEdit = _typeUser == "admin" ? '/admin/clientes/'+row.client_slug+'/ofertas/'+ row.id +'/edit' : '/empresa/ofertas/'+ row.id +'/edit'
          var urlRepublished = _typeUser == "admin" ? '/admin/clientes/'+row.client_slug+'/ofertas/new?id='+row.id : '/empresa/ofertas/new?id='+row.id
          
          const editLink = `<a href="${urlEdit}" class="icon tp" data-toggle="tooltip" data-theme="dark" title="${getTranslationValue(config, [language, "OfertsPrivateDatatable", "columns", "Actions", "row_counter_edit_title"], "Editar")}"><i class="far fa-edit"></i></a>`;
          const copyLink = `<a class="copy ofert_copy_link tp mr-5 ml-1" href="#" data-toggle="tooltip" data-theme="dark" title="${getTranslationValue(config, [language, "OfertsPrivateDatatable", "columns", "Actions", "row_counter_copy_title"], "Copiar URL")}" data-tool data-url="${platformUrl}/oferta/${row.id}/${row.slug}"><i class="fas fa-copy"></i></a>`;
          const republishLink = `<a href="${urlRepublished}" class="icon tp" data-toggle="tooltip" data-theme="dark" title="Republicar"><i class="fas fa-cloud-upload-alt"></i></a>`;
          const deleteButton = `<button type="button" class="icon delete-button tp" data-toggle="tooltip" data-theme="dark" title="${getTranslationValue(config, [language, "OfertsPrivateDatatable", "columns", "Actions", "else_row_counter_delete_title"], "Eliminar")}" data-id="${row.id}" data-slug="${row.client_slug}" data-toggle="modal" data-target="#delete_ofert_modal"><i class="fas fa-trash-alt"></i></button>`;
          
          const showDeleteButton = row.counter_postulations == 0;
          const actionButtons = `
            ${editLink}
            ${copyLink}
            ${republishLink}
            ${showDeleteButton ? deleteButton : ''}
          `;
         
          const output = `
            <div class="d-flex align-items-center container-actions-table">
              ${!row.is_archived ? actionButtons : ''}
            </div>
          `;

          return output;
        }
      }],
      search: {
        input: $('#kt_subheader_oferts_search_form'),
      },
    });

    kt_datatable_oferts = datatable
  };

  /*************
    * ELIMINAR OFERTA
    *
    * - Logica de activacion de modal,
    * - Asignacion de informacion a hidden field del modal
    * - Validacion y ejecución del formulario
    */
  var _delete_ofert = function() {
    // Al hacer click en eliminar una oferta
    $("#kt_datatable_oferts").on("click", ".delete-button", function(e){
      $('#delete_ofert_modal').modal('toggle')
      // Obtiene el id de la oferta
      var ofertId = $(this).attr("data-id")
      // Asigna el id de la oferta en el campo hidden del modal
      $("#delete_ofert_modal #hidden_modal_id").val(ofertId)
      // Se asigna la url correspondiente, si el usuario es admin
      if(_typeUser == "admin"){
        var slug = $(this).attr("data-slug")
        var url = '/admin/clientes/'+slug+'/ofertas/'+ofertId+'/destroy';
      // De lo contrario si es reclutador
      } else {
        var url = '/empresa/ofertas/'+ ofertId;
      }
      // Se asigna al form la action
      $("#form_modal_delete_ofert").attr("action", url)
      // Si la oferta se debe archivar porque tiene postulaciones
      if($(this).hasClass("not-delete")){
        // Modifica la descripcion del modal
        const description = getTranslationValue(config, [language, "if_hasClass_not_delete", "description"], "Esta publicación contiene postulaciones, no se puede eliminar pero si quedará archivada. Esta acción no se puede revertir.")
        $("#delete_ofert_modal .modal-body .description").text(description)
        // Modifica el texto del boton
        const btnText = getTranslationValue(config, [language, "if_hasClass_not_delete", "btn"], "Archivar")
        $("#delete_ofert_modal .modal-footer #send_modal_delete_ofert_form").text(btnText)
        // Agrega la clase not-delete para que al enviar el formulario muestre el texto de "Archivando..."
        $("#delete_ofert_modal .modal-footer #send_modal_delete_ofert_form").addClass("not-delete")
      // Si la oferta debe eliminarse modifica la info del modal por si anteriormente el modal fue abierto
      // por alguna oferta que se debio archivar
      } else {
        // Modifica la descripcion del modal
        const description = getTranslationValue(config, [language, "if_hasClass_not_delete", "else_description"], "Esta acción no se puede revertir.")
        $("#delete_ofert_modal .modal-body .description").text(description)
        // Modifica el texto del boton
        const btnText = getTranslationValue(config, [language, "if_hasClass_not_delete", "else_btn"], "Eliminar")
        $("#delete_ofert_modal .modal-footer #send_modal_delete_ofert_form").text(btnText)
        // Quita la clase not-delete para que al enviar el formulario muestre el texto de "Eliminando..."
        $("#delete_ofert_modal .modal-footer #send_modal_delete_ofert_form").removeClass("not-delete")
      }

    })

    // Al cerrar el modal limpia la url y el hidden
    $("#delete_ofert_modal .close").on("click", function(e){
      cleanOfertModalFields()
    })

    // Al hacer click en confirmar eliminacion de oferta
    $("#delete_ofert_modal #cancel_modal_delete_ofert_form").on("click", function(e){
      cleanOfertModalFields()
    })

    // Al hacer click en enviar oferta
    $("#delete_ofert_modal #send_modal_delete_ofert_form").on("click", function(e){
      // Valida que el campo hidden tenga información
      var ofertId = $("#delete_ofert_modal #hidden_modal_id").val()
      // Si tiene informacion ejecuta el formulario
      if(ofertId.length > 0) {
        // Se desabilitan las acciones
        // Si se esta archivando una oferta
        if($(this).hasClass("not-delete")){
          // Cambia el texto del boton a Archivando
          const disabledText = getTranslationValue(config, [language, "on_click_delete_modal", "archived_text"], "Archivando...")
          $(this).addClass("disabled").text(disabledText)
        // De lo contrario esta eliminando una oferta
        } else {
          // Cambia el texto del boton a Eliminando
          const disabledText = getTranslationValue(config, [language, "on_click_delete_modal", "archived_text"], "Eliminando...")
          $(this).addClass("disabled").text("Eliminando...")
        }

        $("#delete_ofert_modal #cancel_modal_delete_ofert_form").addClass("disabled")
        $("#delete_ofert_modal #close_delete_ofert_modal").addClass("disabled")
        $("#form_modal_delete_ofert").submit()
      } else {
        // Si no se puede eliminar
        const modaBodytext = getTranslationValue(config, [language, "modaBodytext"], "Hubo un problema y no se pudo eliminar la oferta. Por favor intente más tarde.")
        $(".modal-body").find(".error-modal").remove()
        $(".modal-body").prepend('<div class="error-modal"><i class="fas fa-times-circle"></i><p>'+modaBodytext+'</p></div>')
      }
    })

    // Limpia el campo hidden y la url del form
    function cleanOfertModalFields(){
      // Limpia si hay errores
      $(".modal-body").find(".error-modal").remove()
      // Limpia el campo hidden
      $("#delete_ofert_modal #hidden_modal_id").val(null)
      // Se limpia la url correspondiente
      var url = '';
      $("#form_modal_delete_ofert").attr("action", url)
    }
    /*************
    * FIN ELIMINAR OFERTA
    */
  }

  var _parsedDate = function(date){  
    // Extraer año, mes y día de la cadena
    var parts = date.split('T')[0].split('-');
    var year = parts[0];
    var month = parts[1];
    var day = parts[2];
    
    // Formatear la fecha en el nuevo formato (DD/MM/YYYY)
    return day + '/' + month + '/' + year;
  }

  return {
    // public functions
    init: function() {
        _init();
        _delete_ofert();

        // Copiar el link
        $('table').on('click', ".ofert_copy_link", function(e) {
          var $temp = $("<input>");
          var $url = $(this).data('url');
          $("body").append($temp);
          $temp.val($url).select();
          document.execCommand("copy");
          $temp.remove();
          const swalFireText = getTranslationValue(config, [language, "on_click_ofert_copy_link_text"], "URL copiada!")
          Swal.fire({icon: 'success', text: swalFireText, showConfirmButton: true });
        });
      
        $("#client-filter").on('change', function() {
          // Obtiene los valores de todos los checkboxes seleccionados
          var filters = $('.data-filter:checked').map(function() {
            return this.value;
          }).get();
      
          // Actualiza la configuración de KTDatatable y recarga los datos
          kt_datatable_oferts.setDataSourceParam('filters', filters);
          kt_datatable_oferts.reload();
        });
    },
  };
}();

$(document).ready(function() {
  if($("#kt_datatable_oferts").length > 0){
    OfertsPrivateDatatable.init();
  }

  $('div#changeStateModal').on("change", "#ofert_enum_state", function(e){
    var state = $(this).val();

    if(state == "closed"){
      const defaultLabelText = 'Estas cerrando esta oferta, cuéntanos, ¿Conseguiste tu candidato a través de ' + ( origin == 1 ? 'Talento Cloud?' : 'FirstJob?')
      const labelText = getTranslationValue(config, [language, "selectQuestion", ( origin == 1 ? 'label_aws' : 'label') ], defaultLabelText);
      
      const defaultOptionText = getTranslationValue(config, [language, "selectQuestion", "default_option"], 'Seleccione una opción');
      const firstOPtionText = getTranslationValue(config, [language, "selectQuestion", "option1"], 'Si');
      const secondOptionText = getTranslationValue(config, [language, "selectQuestion", "option2"], 'No');

      var selectQuestion = '<div id="container-ofert-postulant-found" class="form-group fv-plugins-icon-container">\
                              <label>'+labelText+'</label>\
                              <select id="ofert_postulant_found" class="form-control form-control-lg form-control-solid" name="ofert[postulant_found]">\
                                <option value="">'+defaultOptionText+'</option>\
                                <option value="true">'+firstOPtionText+'</option>\
                                <option value="false">'+secondOptionText+'</option>\
                              </select>\
                            </div>';

      $(this).parent().parent().append(selectQuestion);
    } else {
      $(this).parent().parent().find("#container-ofert-postulant-found").remove();
    }
	})

  $('div#changeStateModal').on("click", "#change_state", function(e){
    const disabledText = getTranslationValue(config, [language, "on_click_change_state_text"], "Enviando Información...");
    $(this).addClass("disabled").text(disabledText);
		$("div#changeStateModal").addClass("disabled");
	})

});

function getTranslationValue(config, keys, defaultValue) {
	if (keys.length <= 1) return defaultValue;
  
	let currentTranslation;
	let firstIteration = true;
  
	for (let key of keys) {

	  if (firstIteration) {

      if (config[key]) {
        currentTranslation = config[key];
        firstIteration = false;
      } else {
        firstIteration = false;
        return defaultValue;
      }
	  } else {
      
      if (currentTranslation[key]) {
        currentTranslation = currentTranslation[key];
      } else {
        return defaultValue;
      }
	  }
	}

	return currentTranslation;
}
